import { ConfirmPartnerNewsImageUploadRequestSchema, ConfirmPartnerNewsImageUploadResponseSchema } from './confirm-partner-news-image-upload.schema';
export const confirmPartnerNewsImageUploadContract = {
    method: 'POST',
    path: '/api/v2/admin/partner-news/:id/images/:slot',
    description: 'Attach an uploaded logo or image to a news entry',
    requestSchema: ConfirmPartnerNewsImageUploadRequestSchema,
    responseSchema: ConfirmPartnerNewsImageUploadResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Bad Request - the upload does not match what was handed out',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - superadmin only',
            404: 'Partner news not found'
        }
    }
};

//# sourceMappingURL=confirm-partner-news-image-upload.contract.js.map